import React from 'react';

function DiagnosticHeader({ showNav = false, onNavClick }) {
  
 const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const headerOffset = 120; // Height of fixed header + padding
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

  return (

    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 shadow-sm print:hidden">  
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
            {/* Logo */}
            <a href="/" className="flex items-center">
            <img
                src={process.env.PUBLIC_URL + '/df-web-logo.svg'}
                alt="Daring Futures"
                className="h-16 border border-[#EAEFF5] rounded"
            />
            </a>

            {/* Navigation */}
            <div className="hidden md:flex items-center gap-6">
            {showNav && (
                <>
                <button
                    onClick={() => scrollToSection('dependency-scores')}
                    className="font-poppins text-sm text-[#062B49] hover:text-[#86C2CA] transition-colors"
                >
                    Scores
                </button>
                <button
                    onClick={() => scrollToSection('radar-chart')}
                    className="font-poppins text-sm text-[#062B49] hover:text-[#86C2CA] transition-colors"
                >
                    Radar
                </button>
                <button
                    onClick={() => scrollToSection('key-insights')}
                    className="font-poppins text-sm text-[#062B49] hover:text-[#86C2CA] transition-colors"
                >
                    Insights
                </button>
                <button
                    onClick={() => scrollToSection('bottom-line')}
                    className="font-poppins text-sm text-[#062B49] hover:text-[#86C2CA] transition-colors"
                >
                    Bottom Line
                </button>
                <button
                    onClick={() => window.print()}
                    className="bg-gray-100 hover:bg-gray-200 text-[#062B49] font-poppins font-semibold px-4 py-2 rounded transition-colors text-sm"
                >
                    Print
                </button>
                </>
            )}
            <a 
                href="https://calendly.com/andrewkidd/truth-session" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-[#86C2CA] hover:bg-[#3B4F6B] text-white font-poppins font-bold px-6 py-2.5 rounded transition-all shadow-sm"
            >
                Book Truth Session
            </a>
            </div>
        </div>
        </header>

  );
}

export default DiagnosticHeader;